module.exports = __webpack_public_path__ + "static/media/logo.f84d08c9.svg";